export function getdataAmat() {
	let obj = {
		formdatajbxx: {
			cains: "",
			qij: "",
			mingxlx: "-1",
			currency: ""
		},
		formlistjbxx: [{
				prop: "cains",
				label: "财务年度	",
				type: "select",
				selectval: [],
				isnotnull: true,
			},
			{
				prop: "qij",
				label: "财务期间	",
				type: "select",
				selectval: [],
				isnotnull: true,

			},
			{
				prop: "mingxlx",
				label: "明细类型	",
				type: "select",
				isnotnull: true,
				selectval: [],

			},
			{
				prop: "currency",
				label: "币种	",
				type: "select",
				selectval: [],
				isnotnull: true,
				slot: true,

			}
		],
	}
	return obj
}
